import React from 'react';
import SharedSearchInput from '../../../../components/shared/SharedSearchInput/SharedSearchInput';

/**
 * EmployeeToolbar Component - Renders the top navigation and search bar.
 */
export function EmployeeToolbar({
    view,
    setView,
    absView,
    setAbsView,
    kolonnenViewMode,
    setKolonnenViewMode,
    filtersRowVisible,
    setFiltersRowVisible,
    onAddEmployee,
    onAddKolonne,
    onManageCategories,
    searchTerm,
    setSearchTerm,
    certSearchTerm,
    setCertSearchTerm,
    urgencyModalOpen,
    setUrgencyModalOpen,
    expiredCount,
    warningCount,
    certViewRef
}) {
    return (
        <div className="employee-header">
            <div className="employee-toolbar">
                <div className="employee-view-toggle">
                    <div className={`employee-nav-item ${(view === 'grid' || view === 'table') ? 'active' : ''}`} onClick={() => setView('grid')}>
                        <span className="btn-icon">👥</span>
                        <span className="btn-text">Mitarbeiter</span>

                        {(view === 'grid' || view === 'table') && (
                            <div className="view-sub-toggle" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className={`sub-toggle-btn ${view === 'grid' ? 'active' : ''}`}
                                    onClick={() => setView('grid')}
                                    title="Kachelansicht"
                                >
                                    🔲
                                </button>
                                <button
                                    className={`sub-toggle-btn ${view === 'table' ? 'active' : ''}`}
                                    onClick={() => setView('table')}
                                    title="Tabellenansicht"
                                >
                                    ≡
                                </button>
                            </div>
                        )}
                    </div>

                    <div className={`employee-nav-item ${view === 'calendar' ? 'active' : ''}`} onClick={() => setView('calendar')}>
                        <span className="btn-icon">🚥</span>
                        <span className="btn-text">Abwesenheiten</span>

                        {view === 'calendar' && (
                            <div className="view-sub-toggle" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className={`sub-toggle-btn ${absView === 'table' ? 'active' : ''}`}
                                    onClick={() => setAbsView('table')}
                                    title="Tabellenansicht"
                                >
                                    ≡
                                </button>
                                <button
                                    className={`sub-toggle-btn ${absView === 'calendar' ? 'active' : ''}`}
                                    onClick={() => setAbsView('calendar')}
                                    title="Kalenderansicht"
                                >
                                    📅
                                </button>
                            </div>
                        )}
                    </div>

                    <div className={`employee-nav-item ${view === 'certificates' ? 'active' : ''}`} onClick={() => setView('certificates')}>
                        <span className="btn-icon">📋</span>
                        <span className="btn-text">Nachweise</span>
                    </div>

                    <div className={`employee-nav-item ${view === 'kolonnen' ? 'active' : ''}`} onClick={() => setView('kolonnen')}>
                        <span className="btn-icon">🏗️</span>
                        <span className="btn-text">Kolonnen</span>

                        {view === 'kolonnen' && (
                            <div className="view-sub-toggle" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className={`sub-toggle-btn ${kolonnenViewMode === 'grid' ? 'active' : ''}`}
                                    onClick={() => setKolonnenViewMode('grid')}
                                    title="Kachelansicht"
                                >
                                    🔲
                                </button>
                                <button
                                    className={`sub-toggle-btn ${kolonnenViewMode === 'list' ? 'active' : ''}`}
                                    onClick={() => setKolonnenViewMode('list')}
                                    title="Listenansicht"
                                >
                                    ≡
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {view === 'certificates' ? (
                    <>
                        <button className={`employee-filter-btn ${filtersRowVisible ? 'active' : ''}`} onClick={() => setFiltersRowVisible(!filtersRowVisible)}>
                            ⚙ Filter
                        </button>

                        <div className="employee-toolbar-urgency" style={{ marginLeft: '10px' }}>
                            <button
                                className={`urgency-toolbar-btn ${urgencyModalOpen ? 'active' : ''}`}
                                onClick={() => setUrgencyModalOpen(true)}
                            >
                                <div className={`urgency-btn-segment expired ${expiredCount > 0 ? 'has-count' : ''}`}>
                                    <span className="btn-icon">🚨</span>
                                    {expiredCount > 0 ? <span>{expiredCount} abgelaufen</span> : <span>0</span>}
                                </div>
                                <div className="urgency-btn-separator" />
                                <div className={`urgency-btn-segment warning ${warningCount > 0 ? 'has-count' : ''}`}>
                                    <span className="btn-icon">⚠️</span>
                                    {warningCount > 0 ? <span>{warningCount} bald fällig</span> : <span>0</span>}
                                </div>
                            </button>
                        </div>

                        <div className="employee-toolbar-spacer" style={{ flex: 1 }} />

                        <div className="employee-search-wrapper">
                            <SharedSearchInput
                                placeholder={view === 'kolonnen' ? 'Kolonne suchen...' : 'Mitarbeiter suchen...'}
                                value={certSearchTerm}
                                onChange={e => setCertSearchTerm(e.target.value)}
                                onClear={() => setCertSearchTerm('')}
                            />
                        </div>

                        <button
                            className="employee-manage-types-btn"
                            onClick={() => certViewRef.current?.setShowDocTypeModal(true)}
                        >
                            <span className="btn-icon">📁</span>
                            Nachweisarten verwalten
                        </button>

                        <button
                            className="employee-add-btn"
                            onClick={() => certViewRef.current?.handleAddDoc()}
                        >
                            + Nachweis hinzufügen
                        </button>
                    </>
                ) : (
                    <>
                        <button className={`employee-filter-btn ${filtersRowVisible ? 'active' : ''}`} onClick={() => setFiltersRowVisible(!filtersRowVisible)}>
                            ⚙ Filter
                        </button>

                        {(view === 'grid' || view === 'table') && (
                            <button className="employee-categories-btn" onClick={onManageCategories}>
                                🏷️ Rollen
                            </button>
                        )}

                        <div className="employee-toolbar-spacer" style={{ flex: 1 }} />

                        <div className="employee-search-wrapper">
                            <SharedSearchInput
                                placeholder={view === 'kolonnen' ? 'Kolonne suchen...' : 'Mitarbeiter suchen...'}
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                onClear={() => setSearchTerm('')}
                            />
                        </div>

                        {(view === 'grid' || view === 'table') && (
                            <button className="employee-add-btn" onClick={onAddEmployee}>
                                + Mitarbeiter hinzufügen
                            </button>
                        )}

                        {view === 'kolonnen' && (
                            <button className="employee-add-btn" onClick={onAddKolonne}>
                                + Neue Kolonne
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
